import React, { useEffect, useState } from "react";
import { useI18n } from "@/i18n/I18nContext";

const STORAGE_KEY = "goalgrid_cookie_consent";

export default function CookieBanner() {
  const { t } = useI18n();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (!stored) setVisible(true);
    } catch (e) { /* ignore */ }
  }, []);

  const decide = (value) => {
    try { localStorage.setItem(STORAGE_KEY, value); } catch (e) { /* ignore */ }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-0 inset-x-0 z-[60] border-t border-white/10 glass"
    >
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8 py-4 flex flex-col md:flex-row items-start md:items-center gap-4">
        <p className="text-sm text-white/80 flex-1">
          {t("cookie.message")}{" "}
          <a href="/privacy" className="text-volt underline hover:no-underline">
            {t("cookie.learn_more")}
          </a>
        </p>
        <div className="flex items-center gap-2">
          <button
            onClick={() => decide("rejected")}
            data-testid="cookie-reject"
            className="px-4 py-2 text-xs uppercase tracking-[0.18em] border border-white/20 text-white/80 hover:border-white/40 transition-colors"
          >
            {t("cookie.reject")}
          </button>
          <button
            onClick={() => decide("accepted")}
            data-testid="cookie-accept"
            className="px-4 py-2 text-xs uppercase tracking-[0.18em] bg-volt text-black font-bold hover:bg-[#b4e500] transition-colors"
          >
            {t("cookie.accept")}
          </button>
        </div>
      </div>
    </div>
  );
}
